import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import FtpBatchModalContent from "./ModalContent/FtpBatchModalContent";
import { useFTPImportBatches } from "./hook/useFTPImportBatches";
type Props = {};

const FtpImportBatches = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  const [selectedRow,setSelectedRow] = useState('')
  const [mode,setMode]=useState('')

  const { data: ftpImportBatchesData } = useFTPImportBatches({
    enable: true,
    params: { page: 1, limit: 10, search: "" },
  });

 

  const ftpBatchDataColumns =(handleEdit:(row:any)=>void)=> [
    {
      name: "Label",
      selector: (row: { Label: string }) => row.Label || "-",
      sortable: true,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "Next Batch",
      selector: (row: { NextBatch: string }) => row.NextBatch ?? "-",
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "FTP Path",
      selector: (row: { FtpPath: string }) => row.FtpPath || "-",
      sortable: true,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "Is enabled",
      selector: (row: { Isenabled: string }) =>
        row.Isenabled == "0" ? "No" : "Yes",
      sortable: true,
      minWidth: "150px",
      wrap: true,
    },
    {
      name: "Action",
      minWidth: "150px",
      cell: (row: any) => (
        <button
          onClick={()=>handleEdit(row)}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];

  console.log(
    "🚀 ~ FtpImport.tsx:132 ~ FtpImport ~ ftpImportBatchesData:",
    ftpImportBatchesData?.data?.FTPImportBatches
  );

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleEdit=(row:any)=>{
setSelectedRow(row)
setMode('edit')
toggleModal()
  }

  const handleAdd=()=>{
    setMode('add')
    toggleModal()
  }


  const handleClose = () => setIsModalOpen(false);

  return (
    <div className="p-4">
      <PageHeader
        title="FTP Import Batches"
        buttons={[
          {
            label: "+ Add FTP Import Batches",
            onClick:()=> handleAdd(),
            color: "#2e8dd3",
          },
        ]}
      />

      <BasicDataTable
      dynamicHeightOnRowsPerPage={true}
        Title="FTP Import Batches"
        data={ftpImportBatchesData?.data?.FTPImportBatches || []}
        columns={ftpBatchDataColumns(handleEdit)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          ftpImportBatchesData?.data?.Pagination?.TotalCount || 0
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={mode=='add'?"Add FTP Import Batch":"Edit FTP Import Batch"}
        size="md"
        content={
          <FtpBatchModalContent
            handleClose={handleClose}
            selectedData={selectedRow}
            mode={mode}
          />
        }
      />
    </div>
  );
};

export default FtpImportBatches;
